import Vue from 'vue'
import Router from 'vue-router'
import All from '@/components/All'
import Darceky from '@/components/Darceky'
import Visacky from '@/components/Visacky'
import Magnetky from '@/components/Magnetky'
import Valentin from '@/components/Valentin'
import Kvietky from '@/components/Kvietky'
import Velkanoc from '@/components/Velkanoc'
import Narodeniny from '@/components/Narodeniny'
import Zvieratka from '@/components/Zvieratka'
import Povolania from '@/components/Povolania'
import Deticky from '@/components/Deticky'
import Svadba from '@/components/Svadba'
import Babatka from '@/components/Babatka'
import Vianoce from '@/components/Vianoce'
import Details from '@/components/Details'
import NotFoundComponent from '@/components/NotFoundComponent'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/velkanoc'
    },
    {
      path: '/darceky',
      name: 'Darceky',
      component: Darceky,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/valentin',
      name: 'Valentin',
      component: Valentin,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/visacky',
      component: Visacky,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/magnetky',
      name: 'Magnetky',
      component: Magnetky,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/kvietky',
      name: 'Kvietky',
      component: Kvietky,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/velkanoc',
      name: 'Velkanoc',
      component: Velkanoc,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/narodeniny',
      name: 'Narodeniny',
      component: Narodeniny,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/zvieratka',
      name: 'Zvieratka',
      component: Zvieratka,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/povolania',
      name: 'Povolania',
      component: Povolania,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/deticky',
      name: 'Deticky',
      component: Deticky,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/svadba',
      name: 'Svadba',
      component: Svadba,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/babatka',
      name: 'Babatka',
      component: Babatka,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '/vianoce',
      name: 'Vianoce',
      component: Vianoce,
      children: [{
        path: ':id',
        component: Details
      }]
    },
    {
      path: '*',
      component: NotFoundComponent
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js